import { render, staticRenderFns } from "./AwaitingPaymentNotice.vue?vue&type=template&id=64c8619a&scoped=true"
import script from "./AwaitingPaymentNotice.vue?vue&type=script&lang=js"
export * from "./AwaitingPaymentNotice.vue?vue&type=script&lang=js"
import style0 from "./AwaitingPaymentNotice.vue?vue&type=style&index=0&id=64c8619a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c8619a",
  null
  
)

export default component.exports